"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleAttributeState = exports.AltTextAttributeState = exports.ImageWidgetMenuState = void 0;
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ImageLinkEditor_1 = require("./ImageLinkEditor/ImageLinkEditor");
var ImageDefaultMenu_1 = require("./ImageDefaultMenu/ImageDefaultMenu");
var ImageFramePanel_1 = __importDefault(require("../ImageFramePanel/ImageFramePanel"));
var AltTextPanel_1 = __importDefault(require("../AltTextPanel/AltTextPanel"));
var ImageFrameRepositionToolbar_1 = __importDefault(require("./ImageFrameRepositionToolbar/ImageFrameRepositionToolbar"));
var ImageTokenMenu_1 = require("./ImageTokenMenu/ImageTokenMenu");
var ImageWidgetMenuState;
(function (ImageWidgetMenuState) {
    ImageWidgetMenuState["None"] = "none";
    ImageWidgetMenuState["PanelOpen"] = "panelopen";
    ImageWidgetMenuState["LinkEditorOpen"] = "linkeditoropen";
    ImageWidgetMenuState["VariableAdderOpen"] = "variableadderopen";
    ImageWidgetMenuState["Repositioning"] = "repositioning";
    ImageWidgetMenuState["AltTextPanelOpen"] = "alttextpanelopen";
})(ImageWidgetMenuState = exports.ImageWidgetMenuState || (exports.ImageWidgetMenuState = {}));
var AltTextAttributeState;
(function (AltTextAttributeState) {
    AltTextAttributeState["Empty"] = "";
})(AltTextAttributeState = exports.AltTextAttributeState || (exports.AltTextAttributeState = {}));
var RoleAttributeState;
(function (RoleAttributeState) {
    RoleAttributeState["Presentation"] = "presentation";
    RoleAttributeState["Empty"] = "";
})(RoleAttributeState = exports.RoleAttributeState || (exports.RoleAttributeState = {}));
var ImageWidgetMenu = (function (_super) {
    __extends(ImageWidgetMenu, _super);
    function ImageWidgetMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.menuElem = react_1.default.createRef();
        _this.updateAlignment = function (alignment) {
            _this.props.updateImage({ alignment: alignment });
            _this.props.telemetry.changedImageAlignment(alignment);
        };
        _this.updateLink = function (href) {
            _this.props.updateImage({ href: href });
        };
        _this.updateToken = function (token) {
            _this.props.updateImage({ variable: token, src: "" });
        };
        _this.updateAltText = function (alt, isImageDecorative) {
            if (isImageDecorative) {
                _this.props.updateImage({
                    role: RoleAttributeState.Presentation,
                });
            }
            else if (alt) {
                _this.props.updateImage({ alt: alt, role: RoleAttributeState.Empty });
            }
            else {
                _this.props.updateImage({
                    alt: AltTextAttributeState.Empty,
                    role: RoleAttributeState.Empty,
                });
            }
        };
        _this.close = function () {
            _this.props.onChangeMenuState(ImageWidgetMenuState.None);
        };
        _this.removeToken = function () {
            _this.props.updateImage({ variable: null });
            _this.props.onChangeMenuState(ImageWidgetMenuState.None);
        };
        _this.togglePanel = function () {
            _this.props.onMenuStateToggle(ImageWidgetMenuState.PanelOpen);
        };
        _this.toggleAltTextPanel = function () {
            _this.props.onMenuStateToggle(ImageWidgetMenuState.AltTextPanelOpen);
        };
        _this.closeLinkInput = function () {
            _this.props.onChangeMenuState(ImageWidgetMenuState.None);
        };
        _this.renderImageFramePanel = function () {
            if (_this.props.menuState === ImageWidgetMenuState.PanelOpen) {
                return (react_1.default.createElement(ImageFramePanel_1.default, { frameType: _this.props.frame, startReposition: _this.props.startRepositioning, onFrameSelect: _this.props.selectFrameType, telemetry: _this.props.telemetry }));
            }
            else {
                return null;
            }
        };
        _this.renderAltTextPanel = function () {
            if (_this.props.menuState === ImageWidgetMenuState.AltTextPanelOpen) {
                return react_1.default.createElement(AltTextPanel_1.default, { alt: _this.props.alt, role: _this.props.role, updateAltText: _this.updateAltText });
            }
            else {
                return null;
            }
        };
        _this.getLeftPosition = function () {
            var _a;
            if (!((_a = _this.menuElem.current) === null || _a === void 0 ? void 0 : _a.parentElement) || !_this.props.imageElem) {
                return 0;
            }
            var menuRect = _this.menuElem.current.getBoundingClientRect();
            var imageRect = _this.props.imageElem.getBoundingClientRect();
            var containerRect = _this.menuElem.current.parentElement.getBoundingClientRect();
            var widthDifference = menuRect.width - imageRect.width;
            var relativeLeft = imageRect.left - containerRect.left;
            return relativeLeft - widthDifference / 2;
        };
        _this.showTokenInput = function () {
            _this.props.onMenuStateToggle(ImageWidgetMenuState.VariableAdderOpen);
        };
        _this.leftPosition = _this.getLeftPosition();
        return _this;
    }
    ImageWidgetMenu.prototype.componentDidUpdate = function () {
        var _this = this;
        var currLeftPosition = this.getLeftPosition();
        (0, mobx_1.runInAction)(function () {
            if (currLeftPosition !== _this.leftPosition) {
                _this.leftPosition = currLeftPosition;
            }
        });
    };
    ImageWidgetMenu.prototype.componentDidMount = function () {
        this.leftPosition = this.getLeftPosition();
    };
    ImageWidgetMenu.prototype.render = function () {
        var _this = this;
        switch (this.props.menuState) {
            case ImageWidgetMenuState.LinkEditorOpen:
                return (react_1.default.createElement(ImageLinkEditor_1.ImageLinkEditor, { href: this.props.href, menuElemRef: this.menuElem, updateLink: this.updateLink, closeLinkInput: this.closeLinkInput, leftPosition: this.leftPosition }));
            case ImageWidgetMenuState.None:
            case ImageWidgetMenuState.PanelOpen:
                return (react_1.default.createElement(ImageDefaultMenu_1.ImageDefaultMenu, { menuElemRef: this.menuElem, leftPosition: this.leftPosition, alignment: this.props.alignment === "left" ? "left" : "center", disableLeftAlignment: this.props.disableLeftAlignment, updateAlignment: this.updateAlignment, renderAltTextPanel: this.renderAltTextPanel, openAltTextPanel: this.toggleAltTextPanel, isPanelOpen: this.props.menuState === ImageWidgetMenuState.PanelOpen, openPanel: this.togglePanel, hasLink: !!this.props.href, openLinkMenu: function () { return _this.props.onChangeMenuState(ImageWidgetMenuState.LinkEditorOpen); }, showTokenInput: this.showTokenInput, deleteImage: this.props.deleteImage, enableImageFrames: this.props.enableImageFrames, showTokensButton: this.props.showTokensButton, hasTokenSet: !!this.props.hasTokenSet, renderImageFramePanel: this.renderImageFramePanel, onReplaceImage: this.props.onReplaceImage }));
            case ImageWidgetMenuState.AltTextPanelOpen:
                return (react_1.default.createElement(ImageDefaultMenu_1.ImageDefaultMenu, { menuElemRef: this.menuElem, leftPosition: this.leftPosition, alignment: this.props.alignment === "left" ? "left" : "center", disableLeftAlignment: this.props.disableLeftAlignment, updateAlignment: this.updateAlignment, renderAltTextPanel: this.renderAltTextPanel, openAltTextPanel: this.toggleAltTextPanel, isAltTextPanelOpen: this.props.menuState === ImageWidgetMenuState.AltTextPanelOpen, openPanel: this.togglePanel, hasLink: !!this.props.href, openLinkMenu: function () { return _this.props.onChangeMenuState(ImageWidgetMenuState.LinkEditorOpen); }, showTokenInput: this.showTokenInput, deleteImage: this.props.deleteImage, enableImageFrames: this.props.enableImageFrames, showTokensButton: this.props.showTokensButton, hasTokenSet: !!this.props.hasTokenSet, renderImageFramePanel: this.renderImageFramePanel, onReplaceImage: this.props.onReplaceImage }));
            case ImageWidgetMenuState.Repositioning:
                return (react_1.default.createElement(ImageFrameRepositionToolbar_1.default, { zoomIn: this.props.zoomIn, zoomOut: this.props.zoomOut, setZoomLevel: this.props.setZoomLevel, currentZoom: this.props.currentZoom, onKeepChanges: this.props.confirmRepositioning, onCancelChanges: this.props.cancelRepositioning, telemetry: this.props.telemetry, leftPosition: this.leftPosition }));
            case ImageWidgetMenuState.VariableAdderOpen:
                return (react_1.default.createElement(ImageTokenMenu_1.ImageTokenMenu, { menuElemRef: this.menuElem, leftPosition: this.leftPosition, token: this.props.variable, confirmToken: this.updateToken, removeToken: this.removeToken, close: this.close }));
            default:
                return null;
        }
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ImageWidgetMenu.prototype, "leftPosition", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidgetMenu.prototype, "togglePanel", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidgetMenu.prototype, "toggleAltTextPanel", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidgetMenu.prototype, "closeLinkInput", void 0);
    ImageWidgetMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageWidgetMenu);
    return ImageWidgetMenu;
}(react_1.default.Component));
exports.default = ImageWidgetMenu;
